export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>"English Voca"</h1>
                <p>"More than 20,000 words for you!</p>
                <a
                  href="https://play.google.com/store/apps/details?id=com.paigesoftware.frequentenglishvoca"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
